import { Headphones, Play, ExternalLink } from "lucide-react";

const fmtDur = (m) => `${m} min`;

export default function PodCard({ pod }) {
  if (!pod) return null;
  const url = pod.external_url || pod.audio_url || pod.link;
  return (
    <article className="pod-card" data-testid={`pod-card-${pod.id}`}>
      <a
        href={url || "#"}
        target={url ? "_blank" : undefined}
        rel={url ? "noopener noreferrer" : undefined}
        onClick={(e) => { if (!url) { e.preventDefault(); } }}
        className="cover block"
        data-testid={`pod-cover-${pod.id}`}
      >
        {pod.cover_image
          ? <img src={pod.cover_image} alt={pod.title} loading="lazy" />
          : <div className="w-full h-full grid place-items-center text-[var(--blue)]"><Headphones size={28} /></div>
        }
        <span className="badge">{fmtDur(pod.duration_min)}</span>
      </a>
      <div className="flex flex-col flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-[0.12em] font-black text-[var(--red)]">Newseze Investigations</div>
        <h3 className="text-[16px] font-black leading-snug text-[var(--ink)] mt-1 line-clamp-2">{pod.title}</h3>
        <p className="text-[12.5px] text-[var(--muted)] mt-1 leading-snug line-clamp-2">{pod.description}</p>
        <div className="mt-auto pt-2 flex items-center gap-2">
          {url ? (
            <a
              href={url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              referrerPolicy="no-referrer"
              className="btn primary icon"
              data-testid={`pod-play-${pod.id}`}
            >
              <Play size={12} fill="white" /> Listen
              <ExternalLink size={10} className="opacity-70" />
            </a>
          ) : (
            <button className="btn primary icon" disabled title="Audio link unavailable" data-testid={`pod-play-${pod.id}`}>
              <Play size={12} fill="white" /> Listen
            </button>
          )}
          <span className="text-[11px] text-[var(--muted)] font-semibold">{pod.host}</span>
        </div>
      </div>
    </article>
  );
}
